/**
 * Patch for @mastra/client-js bug with lowercase query parameters
 *
 * Bug: client.getMemoryThreads() uses ?resourceid= instead of ?resourceId=
 * Location: node_modules/@mastra/client-js/dist/index.js:2870
 *
 * This wrapper fixes the bug by patching the request method to correct
 * query parameter casing before sending requests.
 */

import { MastraClient } from '@mastra/client-js'

/**
 * Creates a patched MastraClient that fixes query parameter casing
 */
export function createPatchedMastraClient(options: any): MastraClient {
  const client = new MastraClient(options)

  // Save original request method
  const originalRequest = (client as any).request.bind(client)

  // Patch request method to fix query parameters
  ;(client as any).request = async function (urlOrPath: string, options?: any) {
    let url = urlOrPath

    // Fix query parameters in URL
    if (url.includes('?')) {
      url = url
        .replace(/([?&])resourceid=/gi, '$1resourceId=')
        .replace(/([?&])agentid=/gi, '$1agentId=')
        .replace(/([?&])threadid=/gi, '$1threadId=')
    }

    // Call original request with fixed URL
    return originalRequest(url, options)
  }

  return client
}

/**
 * Type-safe wrapper
 */
export type PatchedMastraClient = MastraClient
